import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map, take, tap } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { IMenuAuthService } from '@nimbus-library/features/menu/services/contracts/i-menu-auth.service';
import { LocationSelectorModalComponent } from '@nimbus-global/features/geo-location/modals/location-selector-modal/location-selector-modal.component';
import { IAuthenticationService } from '@nimbus-library/features/authentication/services/i-authentication.service';
import { Prompt } from '@nimbus-library/features/authentication/models/authentication.enum';
import { IPermissionManagerService } from '@nimbus-library/features/user-settings/services/contracts/i-permission-manager.service';

@Injectable()
export class MenuAuthService extends IMenuAuthService {
  public constructor(
    private readonly matDialogService: MatDialog,
    private readonly authenticationService: IAuthenticationService,
    private readonly permissionManagerService: IPermissionManagerService,
  ) {
    super();
  }

  public async logout(): Promise<void> {
    return this.authenticationService.logout(
      true,
      {
        autoLogin: false,
        prompt: Prompt.SelectAccount,
      },
      true,
    );
  }

  public canChangeLocation(): Observable<boolean> {
    return this.permissionManagerService.getGlobalPermissionsModel$().pipe(
      distinctUntilChanged(),
      map((model) => !!model && model.locations.length > 1),
    );
  }

  public changeLocation(logOutOnCancel: boolean = false): void {
    this.matDialogService
      .open<LocationSelectorModalComponent>(LocationSelectorModalComponent, {
        closeOnNavigation: true,
      })
      .afterClosed()
      .pipe(
        take(1),
        tap(() => {
          if (logOutOnCancel) {
            return this.authenticationService.logout(false, {}, true);
          }
        }),
      )
      .subscribe();
  }
}
